import * as BasketUpdated from '@ori-events/basket-updated';
export const dispatchBasketUpdatedEvent = (detail, eventType = BasketUpdated.Name) => {
  const event = new CustomEvent(eventType, {
    detail
  });
  window.dispatchEvent(event);
};
export default dispatchBasketUpdatedEvent;
//# sourceMappingURL=dispatchBasketUpdatedEvent.js.map